import moment from 'moment';

const getCurrentWeeksArray = () => {
    const now = moment() // ToDo: timezone
    const weeksArray = []

    for(let i = 0; i < 3; i++) {
        const nowClone = now.clone()
        const week = 0 === i ? nowClone.subtract(1, 'weeks') : nowClone.add(i - 1, 'weeks')

        weeksArray.push({
            isoWeek: week.isoWeek(),
            year: week.day('thursday').year()
        })
    }

    return weeksArray
}

export default getCurrentWeeksArray